/* KirbEbike Blog — reading progress, table of contents highlighting, gallery thumbnails and copy-link sharing. */
(() => {
  const progress = document.querySelector('[data-kb-progress]');
  if (progress) {
    document.body.appendChild(progress);
    const fill = progress.firstElementChild;
    let queued = false;
    const paint = () => {
      queued = false;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      fill.style.transform = `scaleX(${ratio})`;
    };
    const queue = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(paint);
      }
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
  }

  const toc = document.querySelector('.kb-toc');
  if (toc) {
    const links = Array.from(toc.querySelectorAll('a[href^="#"]'));
    const targets = links
      .map((link) => ({ link, el: document.getElementById(decodeURIComponent(link.hash.slice(1))) }))
      .filter((item) => item.el);
    let ticking = false;

    const update = () => {
      ticking = false;
      // Native anchor landing = root scroll padding + the target's scroll margin.
      // Read resolved properties: the underlying sticky-height variable can be calc(...).
      const rootStyle = getComputedStyle(document.documentElement);
      const scrollPadding = parseFloat(rootStyle.scrollPaddingTop) || 0;
      let active = null;
      for (const item of targets) {
        if (item.margin === undefined) item.margin = parseFloat(getComputedStyle(item.el).scrollMarginTop) || 0;
        const scrollMargin = item.margin;
        // Allow fractional-pixel rounding at the final anchor position.
        if (item.el.getBoundingClientRect().top <= scrollPadding + scrollMargin + 2) active = item;
      }
      if (!active && targets.length) active = targets[0];
      links.forEach((link) => {
        const isActive = Boolean(active && link === active.link);
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      // Long contents lists scroll inside the sticky column: keep the current entry in view
      // (scrollTop on the column only, so the page itself never jumps).
      if (active && toc.scrollHeight > toc.clientHeight) {
        const top = active.link.offsetTop;
        const bottom = top + active.link.offsetHeight;
        if (top < toc.scrollTop + 48) toc.scrollTop = Math.max(0, top - 48);
        else if (bottom > toc.scrollTop + toc.clientHeight - 48) toc.scrollTop = bottom - toc.clientHeight + 48;
      }
    };

    const queueUpdate = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', () => { targets.forEach((item) => { item.margin = undefined; }); queueUpdate(); });
    window.addEventListener('hashchange', queueUpdate);
    // Lazy images can move headings without a scroll event.
    document.addEventListener('load', queueUpdate, true);
    update();
  }

  // The phone contents list closes after a jump, so the heading is not hidden behind it.
  document.addEventListener('click', (event) => {
    const jump = event.target.closest('.kb-toc-mobile a');
    if (jump) jump.closest('details').removeAttribute('open');
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.kb-gallery__thumb');
    if (thumb) {
      const gallery = thumb.closest('[data-kb-gallery]');
      const main = gallery && gallery.querySelector('[data-kb-gallery-main]');
      if (main) {
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('.kb-gallery__thumb').forEach((item) => {
          item.classList.toggle('is-active', item === thumb);
          item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
        });
      }
      return;
    }

    const button = event.target.closest('[data-kb-copy]');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.getAttribute('data-kb-copy')).then(() => {
      button.classList.add('is-copied');
      setTimeout(() => button.classList.remove('is-copied'), 1600);
    });
  });
})();
